import { CSSResult, LitElement, TemplateResult, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import css from "./maz-links.scss";

@customElement("maz-links")
export class MaziCraftLinks extends LitElement {
  static get styles(): CSSResult { return css; }

  /**
   * Render the page
   * @returns HTML Template
   */
  render(): TemplateResult {
    return html`<div class="container">
      <h1>Links</h1>
      <p>Coming soon!</p>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "maz-links": MaziCraftLinks;
  }
}
